"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMakeStyles = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */

var react_1 = require("react");

var Object_fromEntries_1 = require("./tools/polyfills/Object.fromEntries");

var objectKeys_1 = require("./tools/objectKeys");

var cssAndCx_1 = require("./cssAndCx");

var getDependencyArrayRef_1 = require("./tools/getDependencyArrayRef");

var typeGuard_1 = require("./tools/typeGuard");

var cache_1 = require("./cache");

var assert_1 = require("./tools/assert");

var mergeClasses_1 = require("./mergeClasses");

var getCounter = function () {
  var counter = 0;
  return function () {
    return counter++;
  };
}();

function createMakeStyles(params) {
  var useTheme = params.useTheme;
  /** returns useStyle. */

  function makeStyles(params) {
    var _ref = params !== null && params !== void 0 ? params : {},
        nameOrWrappedName = _ref.name;

    var name = typeof nameOrWrappedName !== "object" ? nameOrWrappedName : Object.keys(nameOrWrappedName)[0];
    return function (cssObjectByRuleNameOrGetCssObjectByRuleName) {
      var getCssObjectByRuleName = typeof cssObjectByRuleNameOrGetCssObjectByRuleName === "function" ? cssObjectByRuleNameOrGetCssObjectByRuleName : function () {
        return cssObjectByRuleNameOrGetCssObjectByRuleName;
      };
      var outerCounter = getCounter();
      return function useStyles(params, styleOverrides) {
        var _a, _b;

        var theme = useTheme();

        var _ref2 = (0, cssAndCx_1.useCssAndCx)(),
            css = _ref2.css,
            cx = _ref2.cx;

        var cache = (0, cache_1.useTssEmotionCache)();
        var classes = (0, react_1.useMemo)(function () {
          var refClassesCache = {};
          var refClasses = typeof Proxy !== "undefined" && new Proxy({}, {
            "get": function get(_target, propertyKey) {
              if (typeof propertyKey === "symbol") {
                (0, assert_1.assert)(false);
              }

              return refClassesCache[propertyKey] = "".concat(cache.key, "-").concat(outerCounter).concat(name !== undefined ? "-".concat(name) : "", "-").concat(propertyKey, "-ref");
            }
          });
          var cssObjectByRuleName = getCssObjectByRuleName(theme, params, refClasses || {});
          var classes = (0, Object_fromEntries_1.objectFromEntries)((0, objectKeys_1.objectKeys)(cssObjectByRuleName).map(function (ruleName) {
            var cssObject = cssObjectByRuleName[ruleName];

            if (!cssObject.label) {
              cssObject.label = "".concat(name !== undefined ? "".concat(name, "-") : "").concat(ruleName);
            }

            return [ruleName, "".concat(css(cssObject)).concat((0, typeGuard_1.typeGuard)(ruleName, ruleName in refClassesCache) ? " ".concat(refClassesCache[ruleName]) : "")];
          }));
          (0, objectKeys_1.objectKeys)(refClassesCache).forEach(function (ruleName) {
            if (ruleName in classes) {
              return;
            }

            classes[ruleName] = refClassesCache[ruleName];
          });
          return classes;
        }, [cache, css, cx, theme, (0, getDependencyArrayRef_1.getDependencyArrayRef)(params)]);
        var propsClasses = styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.props.classes;
        {
          classes = (0, react_1.useMemo)(function () {
            return (0, mergeClasses_1.mergeClasses)(classes, propsClasses, cx);
          }, [classes, (0, getDependencyArrayRef_1.getDependencyArrayRef)(propsClasses), cx]);
        }
        {
          var _cssObjectByRuleNameOrGetCssObjectByRuleName = undefined;

          try {
            _cssObjectByRuleNameOrGetCssObjectByRuleName = name !== undefined ? (_b = (_a = theme.components) === null || _a === void 0 ? void 0 : _a[name]) === null || _b === void 0 ? void 0 : _b.styleOverrides : undefined; // eslint-disable-next-line no-empty
          } catch (_c) {}

          var themeClasses = (0, react_1.useMemo)(function () {
            if (!_cssObjectByRuleNameOrGetCssObjectByRuleName) {
              return undefined;
            }

            var themeClasses = {};

            for (var ruleName in _cssObjectByRuleNameOrGetCssObjectByRuleName) {
              var cssObjectOrGetCssObject = _cssObjectByRuleNameOrGetCssObjectByRuleName[ruleName];

              if (!(cssObjectOrGetCssObject instanceof Object)) {
                continue;
              }

              themeClasses[ruleName] = css(typeof cssObjectOrGetCssObject === "function" ? cssObjectOrGetCssObject(Object.assign({
                theme: theme,
                "ownerState": styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.ownerState
              }, styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.props)) : cssObjectOrGetCssObject);
            }

            return themeClasses;
          }, [_cssObjectByRuleNameOrGetCssObjectByRuleName === undefined ? undefined : JSON.stringify(_cssObjectByRuleNameOrGetCssObjectByRuleName), (0, getDependencyArrayRef_1.getDependencyArrayRef)(styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.props), (0, getDependencyArrayRef_1.getDependencyArrayRef)(styleOverrides === null || styleOverrides === void 0 ? void 0 : styleOverrides.ownerState), css]);
          classes = (0, react_1.useMemo)(function () {
            return (0, mergeClasses_1.mergeClasses)(classes, themeClasses, cx);
          }, [classes, themeClasses, cx]);
        }
        return {
          classes: classes,
          theme: theme,
          css: css,
          cx: cx
        };
      };
    };
  }

  function useStyles() {
    var theme = useTheme();

    var _ref3 = (0, cssAndCx_1.useCssAndCx)(),
        css = _ref3.css,
        cx = _ref3.cx;

    return {
      theme: theme,
      css: css,
      cx: cx
    };
  }

  return {
    makeStyles: makeStyles,
    useStyles: useStyles
  };
}

exports.createMakeStyles = createMakeStyles;